import Icon from '@cobliteam/ui/icons';
import { AdvancedMarker, AdvancedMarkerAnchorPoint } from '@vis.gl/react-google-maps';
import { useCallback, useMemo } from 'react';

interface TrackingMapMarkersProps {
  points: google.maps.LatLng[];
  highlightPoints: google.maps.LatLng[];
}

const TrackingMapMarkers = ({ points, highlightPoints }: TrackingMapMarkersProps) => {
  const hasOnePoint = highlightPoints.length === 1;

  const basePolylineStartEnd = useMemo(() => {
    if (!points) return null;
    return { start: points[0], end: points[points.length - 1] };
  }, [points]);

  const highlightPolylineStartEnd = useMemo(() => {
    if (!highlightPoints) return null;
    return {
      start: highlightPoints[0],
      end: hasOnePoint ? undefined : highlightPoints[highlightPoints.length - 1],
    };
  }, [highlightPoints, hasOnePoint]);

  const getMarkerPosition = useCallback((point?: google.maps.LatLng) => {
    if (!point) return null;
    return { lat: point.lat(), lng: point.lng() };
  }, []);

  const baseMarkers = useMemo(() => {
    if (!basePolylineStartEnd) return [];

    return [getMarkerPosition(basePolylineStartEnd.start), getMarkerPosition(basePolylineStartEnd.end)];
  }, [basePolylineStartEnd, getMarkerPosition]);

  const highlightMarkers = useMemo(() => {
    if (!highlightPolylineStartEnd) return [];

    return [getMarkerPosition(highlightPolylineStartEnd.start), getMarkerPosition(highlightPolylineStartEnd.end)];
  }, [highlightPolylineStartEnd, getMarkerPosition]);

  return (
    <>
      {baseMarkers.map((marker) =>
        marker ? (
          <AdvancedMarker key={`${marker.lat},${marker.lng}`} anchorPoint={AdvancedMarkerAnchorPoint.CENTER} position={marker}>
            <Icon name='circle' color='black' className='!size-2 fill-black' />
          </AdvancedMarker>
        ) : null
      )}

      {highlightMarkers.map((marker, index) =>
        marker ? (
          <AdvancedMarker key={`${marker.lat},${marker.lng}`} anchorPoint={AdvancedMarkerAnchorPoint.CENTER} position={marker} zIndex={3}>
            <div className='flex size-6 items-center justify-center rounded-full border-4 bg-primary font-bold text-white shadow'>
              {hasOnePoint ? <Icon name='pause' size='xs' /> : index === 0 ? 'A' : 'B'}
            </div>
          </AdvancedMarker>
        ) : null
      )}
    </>
  );
};

export default TrackingMapMarkers;
